<template>
    <div class="public-offer" :class="{ lineMode, highlightOnHover: (!selectByButton && !nonSelectable && !lineMode) }" @click="triggerPublicOfferClick">
        <b-spinner v-if="isLoading" label="isLoading..."></b-spinner>
        <template v-else-if="offer">
            <div class="img-holder">
                <img :src="offer.imagenes_id | img" :alt="offer.ofertaspublicas_id_label" />
            </div>
            <div class="content-holder">
                <div class="textual-content">
                    <h3>{{ offer.ofertaspublicas_id_label }}</h3>
                    <b-row class="no-wrap" :align-h="(lineMode) ? '' : 'center'">
                        <b-col cols="auto">
                            <strong>{{ offer.gbs }}GB</strong>
                        </b-col>
                        <b-col cols="auto" v-if="parseInt(offer.hotspot) == 1">
                            <!-- <p>Hotspot Available</p> -->
                            <i class="fa fa-wifi" aria-hidden="true"></i>
                        </b-col>
                    </b-row>
                    <b-row :align-h="(lineMode) ? '' : 'center'">
                        <b-col cols="auto">
                            <p>{{ offer.duracion }} {{ offer.duracion_unidad }}</p>
                        </b-col>
                    </b-row>

                    <b-row class="price-row" align-h="end">
                        <b-col class="mt-2 mb-2" :class="{ textCenter: lineMode }" cols="12">
                            <span class="price">{{ offer.precio | currency }}</span>
                            <template v-if="offer.precio_nominal > offer.precio">
                                <span class="price-nominal">
                                    {{ offer.precio_nominal | currency }}
                                </span>
                            </template>
                        </b-col>
                    </b-row>

                    <div class="descr" v-html="markedDescription(offer.descr)"></div>
                </div>
                <b-row class="price-row" align-h="end" v-if="selectByButton">
                    <b-col class="mb-3" :class="{ textCenter: !lineMode }" cols="12" v-if="displaySelectButton">
                        <b-button @click="$emit('select', offer.id)"
                            :variant="value === offer.id ? 'primary' : 'outline-primary'">
                            {{ value === offer.id ? 'Seleccionado' : 'Seleccionar' }}
                            <i v-if="value === offer.id" class="fa fa-check" aria-hidden="true"></i>
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>
        <b-jumbotron v-else>
            <template #header>
                No se encontró oferta
            </template>
            <template #lead>
                No pudimos encontrar ninguna oferta que coincida con tus criterios. Por favor, inténtalo de nuevo más
                tarde.
            </template>
        </b-jumbotron>
    </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html';
import { marked } from 'marked'
import _ from 'lodash'

export default {
    name: 'publicOffer',
    props: {
        nonSelectable: {
            type: Boolean,
            default: false
        },
        selectByButton: {
            type: Boolean,
            default: false
        },
        lineMode: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Number, String]
        },
        loadUpURI: {
            type: String,
            default: 'ofertas/getactive'
        },
        displaySelectButton: {
            type: Boolean,
            default: false
        },
        offerId: {
            type: [Number, String]
        },
        offerObj: {
            type: [Object]
        },
        nonSanitized: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // ...mapGetters(['OfertaGetCatalogo']),
        offer() {
            if (this.offerId) {
                return _.find(this.fullOffers, { id: this.offerId });
                // return this.offerFetched
            } else if (this.offerObj) {
                return this.offerObj
            }
        }
    },
    data: () => {
        return {
            isLoading: false,
            fullOffers: null
        }
    },
    methods: {
        triggerPublicOfferClick(){
            if(!this.selectByButton && this.offer) {
                this.$emit('select', this.offer.id);
            }
        },
        async loadUpSingOffer() {
            this.isLoading = true;
            try {
                // RESPONSE
                const response = await axios.get(this.loadUpURI + '/' + this.offerId);

                // GENERAL OBJECT LIKE
                if (!_.isObjectLike(response))
                    throw 'Error de server';

                if (!response.status)
                    throw response.msg;

                this.fullOffers = response.data;
            } catch (error) {
                console.error('Error loading catalog:', error);
            }
            this.isLoading = false;
        },
        markedDescription(desc) {
            if (!desc) {
                return ''
            } else {
                let html = (marked((desc)))
                return (!this.nonSanitized) ? sanitizeHtml(html) : html;
            }
        },
        getSelectedPrice() {
            let precio = 0;
            try {
                if (_.isObject(this.offer) && _.has(this.offer, 'precio'))
                    precio = this.offer.precio;
            } catch (error) {
                console.error('Error getting selected price:', error);
            }
            return precio;
        }
    },
    beforeMount() {
        if (this.offerId) {
            this.loadUpSingOffer()
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

.public-offer {
    width: 100%;
    max-width: 360px;
    display: inline-flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    gap: 1em;
    border-radius: 5px;
    overflow: clip;
    border: $primary-dark-border;
    background-color: $primary-dark;

    &.lineMode {
        border: none;
        background: transparent;


        .img-holder {
            display: none;
        }

        .content-holder {
            padding: 0em !important;

            .textual-content {

                text-align: left;
                
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    text-align: left !important;
                    color: white;
                    font-size: 1rem;
                }

                .price {
                    font-size: 1rem;
                    color: white;
                }

                .price-nominal {
                    margin-left: 0;
                    font-size: 0.7em;
                    top: -0.7em;
                }

                .mb-2,
                .my-2 {
                    margin-bottom: 0;
                }

                hr {
                    border-top: 1px solid rgba(255, 255, 255, 0.34);
                }

                .price-row {
                    text-align: left;
                    margin-bottom: 0em !important;
                }

                .descr {
                    display: none;
                }

                .mt-2,
                .my-2 {
                    margin-top: 0rem !important;
                }

            }

        }

    }

    .img-holder {
        position: relative;
        padding-bottom: 80%;
        height: 0;
        width: 100%;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

    }

    .content-holder {
        position: relative;
        width: 100%;
        // padding-bottom: 100%; /* 2:1 aspect ratio */
        // padding-top: 33.33%; /* 3:1 aspect ratio */
        // padding-bottom: 100%;
        display: flex;
        flex-flow: column;
        padding: 1em;
        // background-color: black;
        // color: white;

        .textual-content {
            // position: absolute;
            // top: 0; left: 0; width: 100%; height: 100%;
            display: flex;
            flex-flow: column;

            h3 {
                text-align: center;
                font-weight: bold;
                // color: $accent;
                font-size: 1.5em;
            }

            h3,
            p,
            span,
            i {
                // color: white;
            }

            .descr {
                text-align: left;
                width: 100%;
            }
        }

        .price-row {

            display: flex;
            justify-content: space-between;
            align-items: right;
            width: 100%;
            margin-bottom: 1em !important;
            text-align: center;

            .price {
                font-size: 1.5em;
                font-weight: bold;
                color: $accent;
            }

            .price-nominal {
                // font-size: 1em;
                font-weight: normal;
                color: $secondary;
                text-decoration: line-through;
                margin-left: 0.5em;
                font-size: 0.8em;
                display: block;
                position: relative;
                top: -0.9em;
                // right: -1.6em;
                height: 0;
            }
        }
    }
}
</style>